<template>
    <article>
        <section>
            <h1>Write-Ups</h1>
            <h3>2014</h3>

            <h2>Build-a-Badguy Workshop</h2>
            <p>The Build a Bad Guy Workshop is a write-up that I posted on Gamasutra and Reddit. Both posts were popular
                and well received by the community and staff. The post on Gamasutra was featured and propagated to the
                home page, resting at the top big box as a feature for a few days.</p>

            <p>The post is a series of attributes that game designers can mix and match to create enemy behavior for
                retro games.</p>

            <p>
                <a href="https://www.gamedeveloper.com/design/build-a-bad-guy-workshop---designing-enemies-for-retro-games"
                   target="_blank">On Gamasutra</a></p>
            <p>
                <a href="https://www.reddit.com/r/gamedev/comments/23oxp6/build_a_bad_guy_workshop_designing_enemies_for/"
                   target="_blank">On Reddit r/Gamedev</a></p>

            <p>I also built <a href="http://garmichael.develteam.com/content/webPlayers/BadGuyWorkshop/" target="_blank">this interactive</a> web app as a companion piece.</p>

            <p>You can add States and Triggers, and connect them. The app features a random state generator, and has
                more attributes than the write-ups have listed.</p>
        </section>
    </article>
</template>

<script>
    export default {
        name: "WriteUps"
    }
</script>